export enum GroupType {
    PMG,
    POC,
    Support,
}
